export const basicProfileQuestions = [
  {
    question: "What best describes your current life stage?",
    options: [
      {
        id: 1,
        value: "Just starting my career",
        points: 1,
        dashboardSettings: [],
      },
      {
        id: 2,
        value: "Mid-career professional",
        points: 2,
        dashboardSettings: [],
      },
      {
        id: 3,
        value: "Approaching retirement",
        points: 3,
        dashboardSettings: [],
      },
      { id: 4, value: "Retired", points: 4, dashboardSettings: [] },
      { id: 5, value: "Student", points: 1, dashboardSettings: [] },
    ],
    select: "single",
  },
  {
    question: "Which financial activities matter most to you? (Select up to 3)",
    options: [
      {
        id: 1,
        value: "Tracking daily spending",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 2,
        value: "Building emergency savings",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
          { id: "dashboardGoalCharts" },
        ],
      },
      {
        id: 3,
        value: "Investing for the future",
        points: 0,
        dashboardSettings: [
          { id: "DashboardSavingsGoal" },
          { id: "InvestmentWatchlistTable" },
          { id: "PortfolioBalancesTable" },
        ],
      },
      {
        id: 4,
        value: "Paying off debt",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 5,
        value: "Budgeting for goals",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
          { id: "dashboardGoalCharts" },
        ],
      },
      {
        id: 6,
        value: "Managing retirement accounts",
        points: 0,
        dashboardSettings: [
          { id: "PortfolioBalancesTable" },
          { id: "InvestmentWatchlistTable" },
        ],
      },
      {
        id: 7,
        value: "Real estate/mortgage planning",
        points: 0,
        dashboardSettings: [
          { id: "DashboardSavingsGoal" },
          { id: "InvestmentWatchlistTable" },
          { id: "PortfolioBalancesTable" },
        ],
      },
    ],
    select: "multiple",
  },
  {
    question: "What's your biggest financial challenge right now?",
    options: [
      {
        id: 1,
        value: "Living paycheck to paycheck",
        points: 1,
        dashboardSettings: [],
      },
      { id: 2, value: "High debt burden", points: 1, dashboardSettings: [] },
      { id: 3, value: "Not saving enough", points: 3, dashboardSettings: [] },
      {
        id: 4,
        value: "Understanding investments",
        points: 4,
        dashboardSettings: [],
      },
      { id: 5, value: "Irregular income", points: 1, dashboardSettings: [] },
      {
        id: 6,
        value: "Large upcoming expenses",
        points: 4,
        dashboardSettings: [],
      },
    ],
    select: "single",
  },
];
export const incomeSpendingOverview = [
  {
    question: "What's your average monthly take-home pay?",
    options: [
      { id: 1, value: "Under $3,000", points: 1, dashboardSettings: [] },
      { id: 2, value: "$3,000 - $5,000", points: 1, dashboardSettings: [] },
      { id: 3, value: "$5,001 - $8,000", points: 2, dashboardSettings: [] },
      { id: 4, value: "$8,001 - $12,000", points: 3, dashboardSettings: [] },
      { id: 5, value: "Over $12,000", points: 4, dashboardSettings: [] },
    ],
    select: "single",
  },
  {
    question: "How do you primarily earn money?",
    options: [
      { id: 1, value: "Regular salary", points: 0, dashboardSettings: [] },
      { id: 2, value: "Hourly wages", points: 0, dashboardSettings: [] },
      {
        id: 3,
        value: "Self-employed/freelance",
        points: 0,
        dashboardSettings: [],
      },
      {
        id: 4,
        value: "Multiple income sources",
        points: 4,
        dashboardSettings: [],
      },
      { id: 5, value: "Investment income", points: 4, dashboardSettings: [] },
    ],
    select: "single",
  },
  {
    question: "Which spending areas would you like to track closely?",
    options: [
      {
        id: 1,
        value: "Housing/utilities",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 2,
        value: "Food/groceries",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 3,
        value: "Transportation",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 4,
        value: "Entertainment",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 5,
        value: "Shopping",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 6,
        value: "Healthcare",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 7,
        value: "Education",
        points: 0,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
    ],
    select: "multiple",
  },
];
export const goalsPlanning = [
  {
    question: "What's your most important financial goal for the next year?",
    options: [
      {
        id: 1,
        value: "Build emergency fund",
        points: 1,
        dashboardSettings: [],
      },
      {
        id: 2,
        value: "Pay off specific debt",
        points: 2,
        dashboardSettings: [],
      },
      {
        id: 3,
        value: "Save for major purchase",
        points: 4,
        dashboardSettings: [],
      },
      { id: 4, value: "Start investing", points: 3, dashboardSettings: [] },
      { id: 5, value: "Increase income", points: 2, dashboardSettings: [] },
      { id: 6, value: "Cut spending", points: 3, dashboardSettings: [] },
    ],
    select: "multiple",
  },
  {
    question: "How comfortable are you making financial decisions?",
    options: [
      {
        id: 1,
        value: "Need lots of guidance",
        points: 0,
        dashboardSettings: [],
      },
      { id: 2, value: "Somewhat confident", points: 0, dashboardSettings: [] },
      { id: 3, value: "Very confident", points: 0, dashboardSettings: [] },
      { id: 4, value: "Expert level", points: 0, dashboardSettings: [] },
    ],
    select: "single",
  },
  {
    question: "How would you like to learn about financial topics?",
    options: [
      {
        id: 1,
        value: "Quick tips and alerts",
        points: 0,
        dashboardSettings: [],
      },
      { id: 2, value: "Detailed guides", points: 0, dashboardSettings: [] },
      { id: 3, value: "Interactive tools", points: 0, dashboardSettings: [] },
      { id: 4, value: "Video tutorials", points: 0, dashboardSettings: [] },
      {
        id: 5,
        value: "Community discussions",
        points: 0,
        dashboardSettings: [],
      },
    ],
    select: "multiple",
  },
];
export const featurePreferences = [
  {
    question: "Which tools would you use most? (Select all that apply)",
    options: [
      {
        id: 1,
        value: "Bill payment reminders",
        points: 0,
        dashboardSettings: [],
      },
      { id: 2, value: "Automated savings", points: 0, dashboardSettings: [] },
      {
        id: 3,
        value: "Investment tracking",
        points: 4,
        dashboardSettings: [
          { id: "DashboardSavingsGoal" },
          { id: "PortfolioBalancesTable" },
          { id: "InvestmentWatchlistTable" },
        ],
      },
      {
        id: 4,
        value: "Budget notifications",
        points: 2,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 5,
        value: "Expense categorization",
        points: 3,
        dashboardSettings: [
          { id: "budgetExpanse" },
          { id: "topMonthlyExpanse" },
          { id: "UpcomingBillsTable" },
          { id: "IncomeAndExpensChart" },
        ],
      },
      {
        id: 6,
        value: "Goal progress tracking",
        points: 4,
        dashboardSettings: [
          { id: "DashboardSavingsGoal" },
          { id: "dashboardGoalCharts" },
        ],
      },
      {
        id: 7,
        value: "Financial education resources",
        points: 0,
        dashboardSettings: [],
      },
    ],
    select: "multiple",
  },
  {
    question: "How often do you want to check your finances?",
    options: [
      { id: 1, value: "Daily", points: 0, dashboardSettings: [] },
      { id: 2, value: "Weekly", points: 0, dashboardSettings: [] },
      { id: 3, value: "Monthly", points: 0, dashboardSettings: [] },
      { id: 4, value: "Quarterly", points: 0, dashboardSettings: [] },
    ],
    select: "single",
  },
  {
    question: "Would you like to connect your financial accounts?",
    options: [
      { id: 1, value: "Yes, all accounts", points: 0, dashboardSettings: [] },
      {
        id: 2,
        value: "Yes, but only some accounts",
        points: 0,
        dashboardSettings: [],
      },
      {
        id: 3,
        value: "No, I'll enter data manually",
        points: 0,
        dashboardSettings: [],
      },
    ],
    select: "single",
  },
];

export const beginnerUserSetting = {
  dashboard1DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardCalendar" },
    { id: "budgetExpanse" },
    { id: "topMonthlyExpanse" },
    { id: "IncomeAndExpensChart" },
    { id: "TasksList" },
  ],

  dashboard2DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardCalendar" },
    { id: "budgetExpanse" },
    { id: "topMonthlyExpanse" },
    { id: "IncomeAndExpensChart" },
    { id: "TasksList" },
  ],
  dashboard3DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardCalendar" },
    { id: "budgetExpanse" },
    { id: "topMonthlyExpanse" },
    { id: "IncomeAndExpensChart" },
    { id: "TasksList" },
  ],
};
export const intermediateUserSetting = {
  dashboard1DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardSavingsGoal" },
    { id: "dashboardGoalCharts" },
    { id: "topMonthlyExpanse" },
    { id: "LatestNews" },
    { id: "TasksList" },
    { id: "InvestmentWatchlistTable" },
  ],

  dashboard2DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardSavingsGoal" },
    { id: "dashboardGoalCharts" },
    { id: "topMonthlyExpanse" },
    { id: "LatestNews" },
    { id: "TasksList" },
    { id: "InvestmentWatchlistTable" },
  ],
  dashboard3DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardSavingsGoal" },
    { id: "dashboardGoalCharts" },
    { id: "topMonthlyExpanse" },
    { id: "LatestNews" },
    { id: "TasksList" },
    { id: "InvestmentWatchlistTable" },
  ],
};
export const advancedUserSetting = {
  dashboard1DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardSavingsGoal" },
    { id: "dashboardGoalCharts" },
    { id: "LatestNews" },
    { id: "InvestmentWatchlistTable" },
  ],

  dashboard2DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardSavingsGoal" },
    { id: "dashboardGoalCharts" },
    { id: "LatestNews" },
    { id: "InvestmentWatchlistTable" },
  ],
  dashboard3DragCards: [
    { id: "UpcomingBillsTable" },
    { id: "DashboardSavingsGoal" },
    { id: "dashboardGoalCharts" },
    { id: "LatestNews" },
    { id: "InvestmentWatchlistTable" },
  ],
};
